import {Component, EventEmitter, Input, Output} from '@angular/core';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CheckboxIconComponent} from '../../../../shared/components/checkbox-icon/checkbox-icon.component';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {ConsentStatus} from '../../../../domain/data/consent-status';

@Component({
  selector: 'app-data-sharing',
  imports: [
    CheckboxIconComponent,
  ],
  templateUrl: './data-sharing.component.html',
})
export class DataSharingComponent {
  @Input() brand: VehicleBrand
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() descriptionText: string;
  @Output() didChange = new EventEmitter<void>();

  textExpanded = false;

  protected readonly ConsentStatus = ConsentStatus;

  get clampedText(): string {
    if (this.textExpanded || this.descriptionText.length <= 180) {
      return this.descriptionText;
    }

    const words = this.descriptionText.slice(0, 180).split(' ');
    words.pop();
    return words.join(' ') + '...';
  }

  getDataSharingIcon(icon: 'checked' | 'unchecked') {
    const dataSharing = this.customerConsentRequest?.dataSharing;
    const iconMappings = {
      checked: {
        condition: dataSharing === ConsentStatus.CONFIRMED,
        true: 'box-checked-green',
        false: 'box-checked-grey'
      },
      unchecked: {
        condition: dataSharing === ConsentStatus.WITHDRAWN,
        true: 'box-unchecked-red',
        false: 'box-unchecked-grey'
      }
    };
    const mapping = iconMappings[icon];
    return mapping ? (mapping.condition ? mapping.true : mapping.false) : undefined;
  }

  change(value: ConsentStatus) {
    this.customerConsentRequest.dataSharing = value;
    this.didChange.emit();
  }

  toggleExpand() {
    this.textExpanded = !this.textExpanded;
  }
}
